import ReactDOMClient from "react-dom/client";
import { App } from "./App";
import { prefetchGamesEnabled } from "./hooks/useGamesEnabled";
import { preloadDeviceFingerprint } from "./utils/deviceSignals";
import { hydrateAuthStorage } from "./utils/authHeaders";
import { installOverlayDismissGuard } from "./utils/overlayDismissGuard";
import { respectDeviceSilentSwitch } from "./utils/respectDeviceSilentSwitch";

// Restore the auth cookie mirror from durable localStorage before anything reads it.
// Privacy browsers (Firefox ETP, DuckDuckGo) purge first-party cookies; localStorage survives.
hydrateAuthStorage();
respectDeviceSilentSwitch();
installOverlayDismissGuard();

preloadDeviceFingerprint();
prefetchGamesEnabled();

// Injected at runtime: a `<link rel="manifest">` in index.html would need Parcel's webmanifest transformer.
const manifestLink = document.createElement("link");
manifestLink.rel = "manifest";
manifestLink.href = "/site.webmanifest";
document.head.appendChild(manifestLink);

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);

// Prefetch only above-the-fold chunks for "/" to avoid competing with main bundle and LCP image
import("./components/Layout");
import("./components/Games");
import("./components/Header");

root.render(<App />);
